import { render, staticRenderFns } from "./VesselTrials.vue?vue&type=template&id=7b564fbd&scoped=true&"
import script from "./VesselTrials.vue?vue&type=script&lang=js&"
export * from "./VesselTrials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b564fbd",
  null
  
)

export default component.exports